import { colorSet } from '@components/Provider';
import { Theme } from '@material-ui/core';
import {
  CSSProperties,
  CreateCSSProperties
} from '@material-ui/core/styles/withStyles';

type StyleSheetType = CSSProperties | CreateCSSProperties<{}>;

const ChatHeaderStyleSheet = (
  isMobile: string,
  theme: Theme
): StyleSheetType => {
  return {
    zIndex: theme.zIndex.drawer - 1,
    width: '100%',
    height: '100%',
    backgroundColor: 'transparent',
    maxHeight: 49,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    [isMobile]: {
      backgroundColor: colorSet.gray200
    },
    '& .user-name': {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      '& svg': {
        width: 16,
        height: 16,
        color: colorSet.gray700
      }
    },
    '& .go-back-button': {
      width: 24,
      height: 24
    },
    '& .more-button': {
      width: 24,
      height: 24,
      '& svg': {
        transform: 'rotate(90deg)'
      }
    }
  };
};

export default ChatHeaderStyleSheet;
